import React, { useEffect, useState } from "react"
import Canadainsuline from "./Canadainsuline";
import Usinsuline from "./Usinsuline";

class InsulinIndex extends React.Component{
   constructor(props){
    super(props);

    this.state={
        userDetails:''
    }
    
   } 
   componentDidMount(){
    if(localStorage.getItem('setUser')!=null){
        let data=localStorage.getItem('setUser');
        let parseData=JSON.parse(data);
        this.setState({userDetails:parseData?.userInfo});
    }
   }
   render(){
    
return<>
{this.state.userDetails?.country_view_id!=''?(this.state.userDetails?.country_view_id==2?<Canadainsuline/>:<Usinsuline/>):(this.state.userDetails.country_id==2?<Canadainsuline/>:<Usinsuline/>)}
</>
   }
}

export default InsulinIndex;